import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  OnInit,
} from '@angular/core';
import { Filter } from '../../helpers/types/filter.type';
import { ColumnFilterDefinition } from '../../models/column-filter-definition';
import { InitialFilterLoaderService } from '../../services/initial-filter-loader.service';
import { BaseFilter } from './base-filter';

@Component({
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export abstract class ExternalFilterComponent<T>
  extends BaseFilter<T>
  implements OnInit
{
  private readonly initialFilterLoader = inject(InitialFilterLoaderService);
  protected readonly destroyRef = inject(DestroyRef);

  constructor() {
    super();
  }

  ngOnInit(): void {
    const isExternal = true;
    const filterDefinition: Filter = this.columnFilterDefinition();
    const columnFilterDefinition = new ColumnFilterDefinition({
      key: filterDefinition.oDataPath!,
      label: '',
      isFilterable: true,
      filterableColumn: filterDefinition,
    });
    this.filterDefinition.set(columnFilterDefinition);
    const filterColumn = this.selectedFilter();
    filterColumn.build(columnFilterDefinition, isExternal);
    filterColumn.checkSessionFn = this.checkAndSetSessionValue.bind(this);
    this.initialFilterLoader.addExternalFilter(filterColumn);
    this.loadFilterComponent();
  }

  protected updateExternalValue(value: T): void {
    const filterColumn = this.selectedFilter();
    filterColumn.updateValue(value);
    this.filterDefinition()?.queryBuilder(filterColumn, new Map());
    this.updateSession(filterColumn);
    this.updateFilter.next(filterColumn);
  }

  abstract columnFilterDefinition(): Filter;
}
